/**
 * Auto-generated FontAwesome icon registry
 * Generated from Sanity content + hardcoded components at build time
 * DO NOT EDIT - Run `pnpm run generate-icons` to regenerate
 *
 * ⚡ This file contains ONLY the icon definitions used in your content
 * No imports from @fortawesome packages - prevents 3MB+ bundle bloat
 *
 * Icons found: 42 (20 solid, 22 regular)
 * Hardcoded icons: 16 (faAnchor (solid), faAngleDown (regular), faBars (regular), faBadgeCheck (regular), faCheck (regular), faCheck (solid), faCircleCheck (regular), faCircleCheck (solid), faCheckCircle (regular), faMinus (regular), faPlus (regular), faChevronDown (solid), faClose (regular), faCopy (solid), faGlobe (regular), faAngleRight (solid))
 */

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export type FontAwesomeStyle = 'solid' | 'regular'

// Hardcoded icons (used in components but not in Sanity)
const HARDCODED_ICONS_LIST = [
  'faAnchor (solid)',
  'faAngleDown (regular)',
  'faBars (regular)',
  'faBadgeCheck (regular)',
  'faCheck (regular)',
  'faCheck (solid)',
  'faCircleCheck (regular)',
  'faCircleCheck (solid)',
  'faCheckCircle (regular)',
  'faMinus (regular)',
  'faPlus (regular)',
  'faChevronDown (solid)',
  'faClose (regular)',
  'faCopy (solid)',
  'faGlobe (regular)',
  'faAngleRight (solid)',
]

// Manual icon definitions - no package imports needed
const ICON_REGISTRY: Record<FontAwesomeStyle, Record<string, any>> = {
  solid: {
    faChevronRight: {
      prefix: 'fas',
      iconName: 'chevron-right',
      icon: [
        320,
        512,
        [9002],
        'f054',
        'M311.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L243.2 256 73.9 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z',
      ],
    },
    faSportsball: {
      prefix: 'fas',
      iconName: 'sportsball',
      icon: [
        512,
        512,
        [],
        'e44b',
        'M489.6 56.8L377.7 168.8c32.6 26.1 72.9 42.9 116.9 46.5 7.4-56.9 3.6-113-4.9-158.4zm-33.9-34c-59.6-9.5-112.2-11.1-158.6-5.9 3.4 44.4 20.3 85.1 46.6 117.9l112-112zm-9.3 335.6c18.4-29.9 31-62.5 39.2-95.7-53.8-5.4-102.8-27-142.1-59.8L290.4 256 424.2 389.8c8.2-10 15.6-20.5 22.2-31.4zM309.6 168.9c-33.1-39.8-54.8-89.4-59.9-143.9-14.1 3.3-27.5 7.4-40.3 12.1-34.1 12.7-63 30-87.1 50.7l134.2 134.2 53.1-53.1zM88.8 122.2c-8.2 10-15.6 20.5-22.2 31.4-18.4 29.9-31 62.5-39.2 95.7 53.8 5.4 102.8 27 142.1 59.8L222.6 256 88.8 122.2zM263.3 487c14.1-3.3 27.5-7.4 40.3-12.1 34.1-12.7 63-30 87.1-50.7l-134.2-134.2-53.1 53.1c33.1 39.8 54.8 89.4 60 143.9zM169.3 377.2l-112 112c59.6 9.5 112.2 11.1 158.6 5.9-3.4-44.4-20.3-85.1-46.6-117.9zm-33.9-33.9c-32.6-26.1-72.9-42.9-116.9-46.5-7.4 57-3.6 113 4.9 158.4L135.3 343.2z',
      ],
    },
    faNewspaper: {
      prefix: 'fas',
      iconName: 'newspaper',
      icon: [
        512,
        512,
        [128240],
        'f1ea',
        'M0 416L0 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 288c0 13.3 10.7 24 24 24s24-10.7 24-24L96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM160 128l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-240 0zm-24-72c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-240 0c-13.3 0-24 10.7-24 24zM360 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0z',
      ],
    },
    faPeopleGroup: {
      prefix: 'fas',
      iconName: 'people-group',
      icon: [
        512,
        512,
        [],
        'e533',
        'M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm96 312c0 25-12.7 47-32 59.9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1C172.7 359 160 337 160 312l0-40c0-53 43-96 96-96s96 43 96 96l0 40zM96 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm16 240l0 32c0 32.5 12.1 62.1 32 84.7l0 75.3c0 1.2 0 2.5 .1 3.7-8.5 7.6-19.7 12.3-32.1 12.3l-32 0c-26.5 0-48-21.5-48-48l0-56.6C12.9 364.4 0 343.7 0 320l0-32c0-53 43-96 96-96 12.7 0 24.8 2.5 35.9 6.9-12.6 21.4-19.9 46.4-19.9 73.1zM368 464l0-75.3c19.9-22.5 32-52.2 32-84.7l0-32c0-26.7-7.3-51.6-19.9-73.1 11.1-4.5 23.2-6.9 35.9-6.9 53 0 96 43 96 96l0 32c0 23.7-12.9 44.4-32 55.4l0 56.6c0 26.5-21.5 48-48 48l-32 0c-12.3 0-23.6-4.6-32.1-12.3 0-1.2 .1-2.5 .1-3.7zM416 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112z',
      ],
    },
    faPlane: {
      prefix: 'fas',
      iconName: 'plane',
      icon: [
        576,
        512,
        [],
        'f072',
        'M520 200c30.9 0 56 25.1 56 56s-25.1 56-56 56l-127.3 0-159.2 173.6c-6.1 6.6-14.6 10.4-23.6 10.4l-43.7 0c-10.9 0-18.6-10.7-15.2-21.1l54.3-162.9-99.7 0-52.8 66c-3 3.8-7.6 6-12.5 6l-19.8 0c-10.4 0-18-9.8-15.5-19.9L32 256 5 147.9C2.4 137.8 10.1 128 20.5 128l19.8 0c4.9 0 9.5 2.2 12.5 6l52.8 66 99.7 0-54.3-162.9C147.6 26.7 155.3 16 166.2 16l43.7 0c9 0 17.5 3.8 23.6 10.4L392.7 200 520 200z',
      ],
    },
    faBookBookmark: {
      prefix: 'fas',
      iconName: 'book-bookmark',
      icon: [
        448,
        512,
        [],
        'e0bb',
        'M96 512l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-66.7c18.6-6.6 32-24.4 32-45.3l0-288c0-26.5-21.5-48-48-48l-48 0 0 169.4c0 12.5-10.1 22.6-22.6 22.6-6 0-11.8-2.4-16-6.6L272 144 230.6 185.4c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6L192 0 96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96zM64 416c0-17.7 14.3-32 32-32l256 0 0 64-256 0c-17.7 0-32-14.3-32-32z',
      ],
    },
    faCode: {
      prefix: 'fas',
      iconName: 'code',
      icon: [
        576,
        512,
        [],
        'f121',
        'M360.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm64.6 136.1c-12.5 12.5-12.5 32.8 0 45.3l73.4 73.4-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zm-274.7 0c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 150.6 182.6c12.5-12.5 12.5-32.8 0-45.3z',
      ],
    },
    faBowlHot: {
      prefix: 'fas',
      iconName: 'bowl-hot',
      icon: [
        512,
        512,
        ['soup'],
        'f823',
        'M152.1-16c-13.3 0-24 10.7-24 24l0 8c0 32.7 15.4 63.6 41.6 83.2 14.1 10.6 22.4 27.2 22.4 44.8l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-32.7-15.4-63.6-41.6-83.2-14.1-10.6-22.4-27.2-22.4-44.8l0-8c0-13.3-10.7-24-24-24zM33.7 224C15.4 224 1 239.3 2.1 257.5 7.5 349.3 61.7 427.2 138.5 467.2l1.2 9.7c2.5 20 19.5 35 39.7 35l153.4 0c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7 1.1-18.2-13.4-33.5-31.6-33.5L33.7 224zM304.1 8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 32.7 15.4 63.6 41.6 83.2 14.1 10.6 22.4 27.2 22.4 44.8l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-32.7-15.4-63.6-41.6-83.2-14.1-10.6-22.4-27.2-22.4-44.8l0-8z',
      ],
    },
    faGamepad: {
      prefix: 'fas',
      iconName: 'gamepad',
      icon: [
        640,
        512,
        [],
        'f11b',
        'M448 64c106 0 192 86 192 192S554 448 448 448l-256 0C86 448 0 362 0 256S86 64 192 64l256 0zM192 176c-13.3 0-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32c0-13.3-10.7-24-24-24zm240 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64-96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
      ],
    },
    faPaw: {
      prefix: 'fas',
      iconName: 'paw',
      icon: [
        512,
        512,
        [],
        'f1b0',
        'M234.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5 .3-86.2 32.6-96.8 70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3-14.3-70.1 10.2-84.1 59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5l0 1.6c0 25.8-20.9 46.7-46.7 46.7-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2-25.8 0-46.7-20.9-46.7-46.7l0-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3 29.1 51.7 10.2 84.1-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5 46.9 53.9 32.6 96.8-52.1 69.1-84.4 58.5z',
      ],
    },
    faHouseChimneyHeart: {
      prefix: 'fas',
      iconName: 'house-chimney-heart',
      icon: [
        512,
        512,
        [],
        'e1b2',
        'M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208zm15.4 238.9c-11.1-14.8-28.5-23.5-46.9-23.5-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 49.1 65.8 98.1 96.5 118.3 9.5 6.2 21.5 6.2 30.9 0 30.7-20.2 96.5-69.3 96.5-118.3l0-5.3c0-32.4-26.3-58.7-58.7-58.7-18.5 0-35.9 8.7-46.9 23.5l-6.4 8.5-6.4-8.5z',
      ],
    },
    faMagnifyingGlass: {
      prefix: 'fas',
      iconName: 'magnifying-glass',
      icon: [
        512,
        512,
        [128269, 'search'],
        'f002',
        'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z',
      ],
    },
    faCalendarCirclePlus: {
      prefix: 'fas',
      iconName: 'calendar-circle-plus',
      icon: [
        576,
        512,
        [],
        'e470',
        'M192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-32 0c-35.3 0-64 28.7-64 64l0 48 448 0 0-48c0-35.3-28.7-64-64-64l-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-128 0 0-32zM32 416c0 35.3 28.7 64 64 64l161.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-78.7 47.4-146.4 115.1-176L32 224 32 416zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z',
      ],
    },
    faHammer: {
      prefix: 'fas',
      iconName: 'hammer',
      icon: [
        640,
        512,
        [128296],
        'f6e3',
        'M246.9 18.3L271 3.8c21.6-13 46.3-19.8 71.5-19.8 36.8 0 72.2 14.6 98.2 40.7l63.9 63.9c15 15 23.4 35.4 23.4 56.6l0 30.9 19.7 19.7 0 0c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-64 64c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L464 240 433.1 240c-21.2 0-41.6-8.4-56.6-23.4l-49.1-49.1c-15-15-23.4-35.4-23.4-56.6l0-12.7c0-11.2-5.9-21.7-15.5-27.4l-41.6-25c-10.4-6.2-10.4-21.2 0-27.4zM50.7 402.7l222.1-222.1 90.5 90.5-222.1 222.1c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5z',
      ],
    },
    faAnchor: {
      prefix: 'fas',
      iconName: 'anchor',
      icon: [
        576,
        512,
        [9875],
        'f13d',
        'M288 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 96c0-53 43-96 96-96s96 43 96 96c0 41.8-26.7 77.4-64 90.5l0 257.9c62.9-14.3 110.2-69.7 111.9-136.5l-16.1 14.1c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9l64-56c9-7.9 22.6-7.9 31.6 0l64 56c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3L496 307.9C493.9 421 401.6 512 288 512S82.1 421 80 307.9L63.8 322.1c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9l64-56c9-7.9 22.6-7.9 31.6 0l64 56c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3l-16.1-14.1c1.8 66.8 49.1 122.2 111.9 136.5l0-257.9c-37.3-13.2-64-48.7-64-90.5z',
      ],
    },
    faCheck: {
      prefix: 'fas',
      iconName: 'check',
      icon: [
        448,
        512,
        [10003, 10004],
        'f00c',
        'M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z',
      ],
    },
    faCircleCheck: {
      prefix: 'fas',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        [61533, 'check-circle'],
        'f058',
        'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z',
      ],
    },
    faChevronDown: {
      prefix: 'fas',
      iconName: 'chevron-down',
      icon: [
        448,
        512,
        [],
        'f078',
        'M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z',
      ],
    },
    faCopy: {
      prefix: 'fas',
      iconName: 'copy',
      icon: [
        448,
        512,
        [],
        'f0c5',
        'M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z',
      ],
    },
    faAngleRight: {
      prefix: 'fas',
      iconName: 'angle-right',
      icon: [
        256,
        512,
        [8250],
        'f105',
        'M247.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L179.2 256 41.9 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z',
      ],
    },
  },
  regular: {
    faBullseyeArrow: {
      prefix: 'far',
      iconName: 'bullseye-arrow',
      icon: [
        576,
        512,
        [127919],
        'f648',
        'M386.7 64.2c-1.7-10.2 1.6-20.6 8.9-27.9l51.2-51.2C455-23 468.8-20.1 473-9.5L496 48 553.5 71c10.7 4.3 13.5 18 5.4 26.2l-51.2 51.2c-7.3 7.3-17.7 10.6-27.9 8.9L429.1 148.9 305 273c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l124.1-124.1-8.4-50.7zM489.9 205.6c16.4-1 32.2-7 45.1-17.3 5.9 21.6 9.1 44.3 9.1 67.8 0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0c23.5 0 46.2 3.2 67.8 9.1-10.3 12.9-16.4 28.7-17.3 45.1-16.1-4-33-6.2-50.4-6.2-114.9 0-208 93.1-208 208s93.1 208 208 208 208-93.1 208-208c0-17.4-2.1-34.3-6.2-50.4zM288 112c12.9 0 25.4 1.7 37.3 4.9L282 160.2c-50.2 3.1-90 44.8-90 95.8 0 53 43 96 96 96 51 0 92.7-39.8 95.8-90l43.3-43.3c3.2 11.9 4.9 24.4 4.9 37.3 0 79.5-64.5 144-144 144s-144-64.5-144-144 64.5-144 144-144z',
      ],
    },
    faBadgeCheck: {
      prefix: 'far',
      iconName: 'badge-check',
      icon: [
        512,
        512,
        [],
        'f336',
        'M256 0c35.9 0 67.8 17 88.1 43.4 33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93C495 188.2 512 220.1 512 256s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6s-35.9-60-31.6-93C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6C188.2 17 220.1 0 256 0zm0 48c-24.1 0-45.1 13.6-55.7 33.6-5.4 10.2-17.3 15.1-28.2 11.7-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172c3.4 11-1.5 22.9-11.7 28.2-20 10.6-33.6 31.6-33.6 55.7s13.6 45.1 33.6 55.7c10.2 5.4 15.1 17.3 11.7 28.2-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7c11-3.4 22.9 1.5 28.2 11.7 10.6 20 31.6 33.6 55.7 33.6s45.1-13.6 55.7-33.6c5.4-10.2 17.3-15.1 28.2-11.7 21.6 6.6 46 1.4 63.1-15.7 17-17 22.3-41.5 15.7-63.1-3.4-11 1.5-22.9 11.7-28.2 20-10.6 33.6-31.6 33.6-55.7s-13.6-45.1-33.6-55.7c-10.2-5.4-15.1-17.3-11.7-28.2 6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2c-11 3.4-22.9-1.5-28.2-11.7-10.6-20-31.6-33.6-55.7-33.6zm57.4 121.9c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5L249.8 338.9c-4.2 5.7-10.7 9.4-17.8 9.8s-14-2.2-18.9-7.3l-46.4-48c-9.2-9.5-9-24.7 .6-33.9s24.7-8.9 33.9 .6l26.5 27.4 85.6-117.7z',
      ],
    },
    faPeopleArrows: {
      prefix: 'far',
      iconName: 'people-arrows',
      icon: [
        512,
        512,
        ['people-arrows-left-right'],
        'e068',
        'M32 64A64 64 0 1 1 160 64 64 64 0 1 1 32 64zM64 208c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l26.2 0 69.8 69.8 0 114.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144.6C12.9 332.4 0 311.7 0 288l0-64c0-35.3 28.7-64 64-64l64 0c3.2 0 6.4 .2 9.5 .7L90.2 208 64 208zM352 488l0-114.2 69.8-69.8 26.2 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-26.2 0-47.3-47.3c3.1-.5 6.3-.7 9.5-.7l64 0c35.3 0 64 28.7 64 64l0 64c0 23.7-12.9 44.4-32 55.4L480 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24zm0-424a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM295 183c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9l-56 56c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l15-15-108.1 0 15 15c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-56-56c-9.4-9.4-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-15 15 108.1 0-15-15c-9.4-9.4-9.4-24.6 0-33.9z',
      ],
    },
    faMicrochipAi: {
      prefix: 'far',
      iconName: 'microchip-ai',
      icon: [
        512,
        512,
        [],
        'e1ec',
        'M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c-35.3 0-64 28.7-64 64l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c0 35.3 28.7 64 64 64l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c35.3 0 64-28.7 64-64l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c0-35.3-28.7-64-64-64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40zM112 128c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16l0-256zm224 44c-11 0-20 9-20 20l0 128c0 11 9 20 20 20s20-9 20-20l0-128c0-11-9-20-20-20zM234.3 184c-3.2-7.3-10.4-12-18.3-12s-15.1 4.7-18.3 12l-56 128c-4.4 10.1 .2 21.9 10.3 26.3s21.9-.2 26.3-10.3l5.3-12 64.8 0 5.3 12c4.4 10.1 16.2 14.7 26.3 10.3s14.7-16.2 10.3-26.3l-56-128zM216 241.9l14.9 34.1-29.8 0 14.9-34.1z',
      ],
    },
    faFileChartColumn: {
      prefix: 'far',
      iconName: 'file-chart-column',
      icon: [
        384,
        512,
        ['file-chart-line'],
        'f659',
        'M64 48l112 0 0 88c0 39.8 32.2 72 72 72l88 0 0 240c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM224 67.9l92.1 92.1-68.1 0c-13.3 0-24-10.7-24-24l0-68.1zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-261.5c0-17-6.7-33.3-18.7-45.3L242.7 18.7C230.7 6.7 214.5 0 197.5 0L64 0zM216 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM128 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z',
      ],
    },
    faMagnifyingGlassDollar: {
      prefix: 'far',
      iconName: 'magnifying-glass-dollar',
      icon: [
        512,
        512,
        ['search-dollar'],
        'f688',
        'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208 93.1 416 208 416zm4-320c-11 0-20 9-20 20l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L168 256c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20z',
      ],
    },
    faArrowUpRight: {
      prefix: 'far',
      iconName: 'arrow-up-right',
      icon: [
        384,
        512,
        [],
        'e09f',
        'M360 64c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1-295 295c-9.4 9.4-24.6 9.4-33.9 0S-2.3 416.4 7 407l295-295-182.1 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0z',
      ],
    },
    faCodeFork: {
      prefix: 'far',
      iconName: 'code-fork',
      icon: [
        448,
        512,
        [],
        'e13b',
        'M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3l0 27.7c0 30.9 25.1 56 56 56l128 0c30.9 0 56-25.1 56-56l0-27.7c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 27.7c0 57.4-46.6 104-104 104l-40 0 0 67.7c32.5 10.2 56 40.5 56 76.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-67.7-40 0c-57.4 0-104-46.6-104-104l0-27.7C23.5 146.1 0 115.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm208 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
      ],
    },
    faGlobe: {
      prefix: 'far',
      iconName: 'globe',
      icon: [
        512,
        512,
        [127760],
        'f0ac',
        'M303.2 413c-21.5 43.7-41.4 51-47.2 51s-25.7-7.3-47.2-51c-17-34.5-29.2-81.6-32.1-133l158.6 0c-3 51.5-15.2 98.6-32.1 133zm32.1-181l-158.6 0c3-51.5 15.2-98.6 32.1-133 21.5-43.7 41.4-51 47.2-51s25.7 7.3 47.2 51c17 34.5 29.2 81.6 32.1 133zm48.1 48l79.2 0c-8.6 74.6-56.7 137.3-122.8 166.4 24-42.8 40.3-102.4 43.6-166.4zm79.2-48l-79.2 0c-3.3-64-19.6-123.6-43.6-166.4 66.1 29.2 114.2 91.8 122.8 166.4zm-334 0l-79.2 0c8.6-74.6 56.7-137.3 122.8-166.4-24 42.8-40.3 102.4-43.6 166.4zM49.4 280l79.2 0c3.3 64 19.6 123.6 43.6 166.4-66.1-29.2-114.2-91.8-122.8-166.4zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z',
      ],
    },
    faCalendar: {
      prefix: 'far',
      iconName: 'calendar',
      icon: [
        448,
        512,
        [128197, 128198],
        'f133',
        'M120 0c13.3 0 24 10.7 24 24l0 40 160 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-40c0-13.3 10.7-24 24-24zm0 112l-56 0c-8.8 0-16 7.2-16 16l0 48 352 0 0-48c0-8.8-7.2-16-16-16l-264 0zM48 224l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192-352 0z',
      ],
    },
    faDistributeSpacingVertical: {
      prefix: 'far',
      iconName: 'distribute-spacing-vertical',
      icon: [
        512,
        512,
        [],
        'e366',
        'M0 56C0 69.3 10.7 80 24 80l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56zM368 208l0 96-224 0 0-96 224 0zM144 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-224 0zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z',
      ],
    },
    faCoins: {
      prefix: 'far',
      iconName: 'coins',
      icon: [
        512,
        512,
        [],
        'f51e',
        'M320 0c48.9 0 93.9 8.4 127.6 21.7 16.7 6.6 31.8 14.9 43.1 24.8 11 9.7 21.3 23.7 21.3 41.5l0 208c0 17.8-10.4 31.8-21.3 41.5-11.3 10-26.3 18.2-43.1 24.8-5 2-10.2 3.8-15.6 5.5l0-51c12.6-5.2 21.5-10.6 26.9-15.4 3.9-3.4 4.9-5.4 5.1-6l0-40.2c-9.8 4.1-20.6 7.7-32 10.8l0-50.1c7.8-2.6 14.7-5.3 20.5-8.2 4.9-2.4 8.6-4.7 11.5-6.7l0-52.7c-5.3 2.6-10.9 5-16.7 7.2-9.1 3.5-19.1 6.6-29.7 9.2-6.7-11.2-14.9-20.3-22.7-27.3-5.3-4.8-10.9-9.1-16.8-13 50.5-6.2 85.8-20.3 85.8-36.6 0-20-64.5-40-144-40-69.1 0-126.8 15.1-140.8 32.2-17.4 .4-34.5 1.7-51.1 3.9 1.4-15.9 11-28.6 21.2-37.5 11.3-10 26.3-18.2 43.1-24.8 33.7-13.3 78.7-21.7 127.6-21.7zM64.4 149.7C98.1 136.4 143.1 128 192 128s93.9 8.4 127.6 21.7c16.7 6.6 31.8 14.9 43.1 24.8 11 9.7 21.3 23.7 21.3 41.5l0 208c0 17.8-10.4 31.8-21.3 41.5-11.3 10-26.3 18.2-43.1 24.8-33.7 13.3-78.7 21.7-127.6 21.7s-93.9-8.4-127.6-21.7c-16.7-6.6-31.8-14.9-43.1-24.8-11-9.7-21.3-23.7-21.3-41.5L0 216c0-17.8 10.4-31.8 21.3-41.5 11.3-10 26.3-18.2 43.1-24.8zm254.9 134C285.6 296.5 240.5 304 192 304s-93.6-7.5-127.3-20.3c-5.8-2.2-11.4-4.6-16.7-7.2l0 52.7c2.8 2.1 6.6 4.3 11.5 6.7 9.1 4.5 20.8 8.7 34.7 12.4 27.7 7.3 62.2 11.8 97.8 11.8s70.1-4.5 97.8-11.8c13.9-3.7 25.6-7.9 34.7-12.4 4.9-2.4 8.6-4.7 11.5-6.7l0-52.7c-5.3 2.6-10.9 5-16.7 7.2zM48 383.3l0 40.2c.2 .6 1.2 2.6 5.1 6 5.7 5 15.3 10.8 28.9 16.2 27.1 10.7 66.1 18.3 110 18.3s82.8-7.6 110-18.3c13.7-5.4 23.2-11.1 28.9-16.2 3.9-3.4 4.9-5.4 5.1-6l0-40.2c-10.4 4.4-21.8 8.1-33.9 11.3-32.1 8.5-70.8 13.3-110.1 13.3s-77.9-4.9-110-13.3c-12.1-3.2-23.6-7-34-11.3zM336 216c0-20-64.5-40-144-40S48 196 48 216c0 22.1 64.5 40 144 40s144-17.9 144-40z',
      ],
    },
    faUserMagnifyingGlass: {
      prefix: 'far',
      iconName: 'user-magnifying-glass',
      icon: [
        640,
        512,
        [],
        'e5c5',
        'M176.5 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM80.5 480c0-70.7 57.3-128 128-128l80.2 0c.8-16.8 4-32.9 9.4-48l-89.6 0c-97.2 0-176 78.8-176 176l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8zm376-192a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm0 192c24.4 0 47.1-7.3 66.1-19.8l60.9 60.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-60.9-60.9c12.6-19 19.9-41.8 19.9-66.3 0-66.3-53.7-120-120-120s-120 53.7-120 120 53.7 120 120 120z',
      ],
    },
    faDistributeSpacingHorizontal: {
      prefix: 'far',
      iconName: 'distribute-spacing-horizontal',
      icon: [
        448,
        512,
        [],
        'e365',
        'M424 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM272 368l-96 0 0-224 96 0 0 224zm48-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224zM48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24L48 24z',
      ],
    },
    faAngleDown: {
      prefix: 'far',
      iconName: 'angle-down',
      icon: [
        384,
        512,
        [8964],
        'f107',
        'M209.5 369c-9.4 9.4-24.6 9.4-33.9 0L15.5 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143 143-143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-160 160z',
      ],
    },
    faBars: {
      prefix: 'far',
      iconName: 'bars',
      icon: [
        448,
        512,
        ['navicon'],
        'f0c9',
        'M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM0 256c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24zM448 424c0 13.3-10.7 24-24 24L24 448c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24z',
      ],
    },
    faCheck: {
      prefix: 'far',
      iconName: 'check',
      icon: [
        448,
        512,
        [10003, 10004],
        'f00c',
        'M438 68.5c10.8 7.7 13.2 22.7 5.5 33.5l-264 368c-4.1 5.7-10.5 9.4-17.5 9.9S148 478 143 473L7 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L157 419 404.5 74c7.7-10.8 22.7-13.2 33.5-5.5z',
      ],
    },
    faCircleCheck: {
      prefix: 'far',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        [61533, 'check-circle'],
        'f058',
        'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm70.7 121.9c7.8-10.7 22.8-13.1 33.5-5.3 10.7 7.8 13.1 22.8 5.3 33.5L243.4 366.1c-4.1 5.7-10.5 9.3-17.5 9.8-7 .5-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36 105.6-145.2z',
      ],
    },
    faCheckCircle: {
      prefix: 'far',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        [61533, 'check-circle'],
        'f058',
        'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm70.7 121.9c7.8-10.7 22.8-13.1 33.5-5.3 10.7 7.8 13.1 22.8 5.3 33.5L243.4 366.1c-4.1 5.7-10.5 9.3-17.5 9.8-7 .5-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36 105.6-145.2z',
      ],
    },
    faMinus: {
      prefix: 'far',
      iconName: 'minus',
      icon: [
        448,
        512,
        [8211, 8722, 10134, 'subtract'],
        'f068',
        'M0 256c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z',
      ],
    },
    faPlus: {
      prefix: 'far',
      iconName: 'plus',
      icon: [
        448,
        512,
        [10133, 61543, 'add'],
        '2b',
        'M248 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0 0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0 0-176z',
      ],
    },
    faClose: {
      prefix: 'far',
      iconName: 'xmark',
      icon: [
        384,
        512,
        [128473, 10005, 10006, 10060, 215, 'close', 'multiply', 'remove', 'times'],
        'f00d',
        'M7.5 105c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l151 151 151-151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-151 151 151 151c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-151-151-151 151c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l151-151-151-151z',
      ],
    },
  },
}

export function getFontAwesomeIcon(
  name: string,
  style: FontAwesomeStyle = 'solid',
): IconDefinition | undefined {
  const icon = ICON_REGISTRY[style]?.[name] as IconDefinition | undefined

  if (!icon) {
    console.warn(
      `FontAwesome icon "${name}" (${style}) not found in registry.\n` +
        `  → If this icon is hardcoded in a component, add it to HARDCODED_ICONS in scripts/generate-icon-registry.ts\n` +
        `  → Then run: pnpm run generate-icons\n` +
        `  → Currently registered hardcoded icons: ${HARDCODED_ICONS_LIST.join(', ')}`,
    )
  }

  return icon
}
